import { createContext, useContext, useState } from "react";

// Creamos el contexto
const OrdenesContext = createContext();

// Provider
export const OrdenesProvider = ({ children }) => {
  const [ordenesSeleccionadas, setOrdenesSeleccionadas] = useState([]);

  // Función para actualizar la selección
  const actualizarSeleccion = (ordenes) => {
    setOrdenesSeleccionadas(ordenes);
  };

  // Función para limpiar
  const limpiarSeleccion = () => setOrdenesSeleccionadas([]);

  return (
    <OrdenesContext.Provider
      value={{
        ordenesSeleccionadas,
        actualizarSeleccion,
        limpiarSeleccion,
      }}
    >
      {children}
    </OrdenesContext.Provider>
  );
};

// Hook para usar el contexto
export const useOrdenes = () => useContext(OrdenesContext);
